import {H2hWidgetTerms} from "./h2h-widget.terms";
import {BaseConfig} from "../../infrastructure/config/base-config";

export class H2hWidgetConfig extends BaseConfig {

  static injectables = [H2hWidgetTerms];

  constructor(terms: H2hWidgetTerms){
    super('h2hWidget', null, terms);
  }
}
